module.exports = __webpack_public_path__ + "img/1-2.07003a90.png";